import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { isUndef } from '@/lib/utils';
/**
 * 默认的id为-1，表明当前没有处理该数据，没有数据为0，表明在该上级行政区下，没有对应的下级行政区
 *
 * 默认从服务器返回的数据结构为 {id, name}
 */

var m = {
  state: function state() {
    return {
      // 所有的province列表原始数据
      _provinceList: [],
      extraProvinceList: [{
        id: -1,
        name: '全国',
        level: 1,
        is_city: false
      }],
      // 所有的 id -> 子类的list
      _listMap: {},
      // 所有的district内容的map，即id -> district<{id, level, name}>
      _districtMap: {
        '-1': {
          id: -1,
          name: '全国',
          level: 1,
          is_city: false
        }
      }
    };
  },
  mutations: {
    /**
     * 准备存储data
     *
     * @param {Number} id 父地区id
     * @param {Array} list 某次请求获得的list内容
     */
    addList: function addList(state, _a) {
      var id = _a.id,
          list = _a.list;
      Vue.set(state._listMap, id, list); // 保存到map中

      list.forEach(function (district) {
        Vue.set(state._districtMap, String(district.id), district);
      });
    },

    /**
     * 设置provinceList
     *
     * @param {Array} provinceList 所有的province列表 [{id: 1, name: '北京市'}]
     */
    setProvinceList: function setProvinceList(state, provinceList) {
      state._provinceList = provinceList;
    }
  },
  actions: {
    /**
     * 获取省列表
     *
     * @param {} forceUpdate 强制更新
     *
     * @return {Array} ProvinceList
     */
    getProvinceList: function getProvinceList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var forceUpdate = (_b === void 0 ? {} : _b).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!(state._provinceList.length === 0)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/framework/top_level_districts')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setProvinceList', data);
                commit('addList', {
                  id: 0,
                  list: data
                });
              }

              _c.label = 2;

            case 2:
              return [2
              /*return*/
              , state._provinceList];
          }
        });
      });
    },

    /**
     * 获取列表
     *
     * @param {} forceUpdate 强制更新
     * @param {} id 父级地区id
     *
     * @return {} 子行政区的内容
     */
    getChildDistricts: function getChildDistricts(_a, _b) {
      var state = _a.state,
          commit = _a.commit;

      var _c = _b === void 0 ? {} : _b,
          forceUpdate = _c.forceUpdate,
          id = _c.id;

      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (!(isUndef(state._listMap[id]) || forceUpdate)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/framework/child_districts', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('addList', {
                  id: id,
                  list: rdata.data
                });
              }

              _d.label = 2;

            case 2:
              return [2
              /*return*/
              , state._listMap[id]];
          }
        });
      });
    }
  }
};
export default m;